"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[126],{

/***/ 28027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CartOverview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41145);
/* harmony import */ var src_utils_numbers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60165);
/* harmony import */ var src_components_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56795);
/* harmony import */ var src_context_CheckoutContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86771);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  margin-bottom: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 32px;\n  margin-bottom: 2px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 28px 32px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 60px;\n  padding-top: 20px;\n  border-top: 3px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject());
var TitleBox = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject1(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"));
var InfoBox = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject2(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"));
var InfoLine = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject3());
var PriceTotal = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject4(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("red"));
function CartOverview() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var checkout = (0,src_context_CheckoutContext__WEBPACK_IMPORTED_MODULE_5__/* .useCheckout */ .Mg)().checkout;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TitleBox, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.H4, {
                        children: "V\xf6rur \xed k\xf6rfu"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__/* .PSmall */ .zK, {
                        children: [
                            checkout === null || checkout === void 0 ? void 0 : checkout.quantity,
                            " ",
                            (checkout === null || checkout === void 0 ? void 0 : checkout.quantity) === 1 ? "vara" : "v\xf6rur"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InfoBox, {
                children: [
                    (checkout === null || checkout === void 0 ? void 0 : (ref = checkout.subtotalPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.amount) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InfoLine, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                children: "Ver\xf0 me\xf0 VSK"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                children: [
                                    (0,src_utils_numbers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(checkout.subtotalPrice.gross.amount),
                                    " kr."
                                ]
                            })
                        ]
                    }) : null,
                    (checkout === null || checkout === void 0 ? void 0 : (ref2 = checkout.subtotalPrice) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tax) === null || ref3 === void 0 ? void 0 : ref3.amount) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InfoLine, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                children: "\xdear af VSK"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                children: [
                                    (0,src_utils_numbers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(checkout === null || checkout === void 0 ? void 0 : (ref4 = checkout.subtotalPrice) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.tax) === null || ref5 === void 0 ? void 0 : ref5.amount),
                                    " kr."
                                ]
                            })
                        ]
                    }) : null,
                    !!(checkout === null || checkout === void 0 ? void 0 : (ref6 = checkout.discount) === null || ref6 === void 0 ? void 0 : ref6.amount) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InfoLine, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                children: "Afsl\xe1ttur"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                color: "red",
                                children: [
                                    (0,src_utils_numbers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(-1 * (checkout === null || checkout === void 0 ? void 0 : (ref7 = checkout.discount) === null || ref7 === void 0 ? void 0 : ref7.amount)),
                                    " kr."
                                ]
                            })
                        ]
                    }),
                    !!(checkout === null || checkout === void 0 ? void 0 : checkout.shippingPrice) && !!(checkout === null || checkout === void 0 ? void 0 : checkout.shippingMethod) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InfoLine, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                    children: "Sendingarkostna\xf0ur"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                    children: [
                                        (0,src_utils_numbers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(checkout === null || checkout === void 0 ? void 0 : (ref8 = checkout.shippingPrice) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.gross) === null || ref9 === void 0 ? void 0 : ref9.amount),
                                        " kr."
                                    ]
                                })
                            ]
                        })
                    }),
                    (checkout === null || checkout === void 0 ? void 0 : (ref10 = checkout.totalPrice) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.gross) === null || ref11 === void 0 ? void 0 : ref11.amount) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PriceTotal, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                color: "black60",
                                children: "Samtals"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.H3, {
                                children: [
                                    (0,src_utils_numbers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(checkout === null || checkout === void 0 ? void 0 : (ref12 = checkout.totalPrice) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.gross) === null || ref13 === void 0 ? void 0 : ref13.amount),
                                    " kr."
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 4126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EK": function() { return /* reexport */ CheckoutCompleteInfoCard; },
  "dX": function() { return /* reexport */ CheckoutPageWrapper; },
  "kB": function() { return /* reexport */ CheckoutRadioCard; },
  "vu": function() { return /* reexport */ CheckoutReceipt; },
  "YK": function() { return /* reexport */ CheckoutReceiptLine; },
  "DS": function() { return /* reexport */ CheckoutReceiptWrapper; },
  "Af": function() { return /* reexport */ CheckoutStatusBar; },
  "pN": function() { return /* reexport */ CheckoutStep; },
  "ch": function() { return /* reexport */ CreditCardForm; },
  "yo": function() { return /* reexport */ CreditCardInfo; },
  "EE": function() { return /* reexport */ CreditCardRadioCard; },
  "oq": function() { return /* reexport */ Delivery; },
  "Qd": function() { return /* reexport */ EmptyCart; },
  "F6": function() { return /* reexport */ Payment; },
  "nk": function() { return /* reexport */ Receiver; },
  "Zj": function() { return /* reexport */ ReceiverCard; },
  "M8": function() { return /* reexport */ Valitor3DSecureProcessingForm; }
});

// UNUSED EXPORTS: CheckoutEmailUpdate, CreditCardFormFields, DeliveryNote, validateCreditCardFormFields

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/remixicon-react/CheckLineIcon.js
var CheckLineIcon = __webpack_require__(19226);
var CheckLineIcon_default = /*#__PURE__*/__webpack_require__.n(CheckLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowLeftLineIcon.js
var ArrowLeftLineIcon = __webpack_require__(4756);
var ArrowLeftLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftLineIcon);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./src/utils/styles.ts
var styles = __webpack_require__(3795);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
;// CONCATENATED MODULE: ./src/components/checkout/CheckoutStatusBar.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  padding-top: 24px;\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  align-items: bottom;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  height: 56px;\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: calc(100% / 3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  line-height: 1;\n  position: relative;\n  z-index: 1;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  height: 6px;\n  bottom: -3px;\n  left: 0;\n  background-color: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  height: 20px;\n  width: 20px;\n  border-radius: 10px;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: -10px;\n  left: calc(50% - 10px);\n\n  svg {\n    display: block;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      width: 60%;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 10px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 10px;\n  font-weight: 500;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}











var CheckoutStep;
(function(CheckoutStep) {
    CheckoutStep["Receiver"] = "receiver";
    CheckoutStep["Delivery"] = "delivery";
    CheckoutStep["Payment"] = "payment";
    CheckoutStep["Complete"] = "complete";
})(CheckoutStep || (CheckoutStep = {}));
var StepStatus;
(function(StepStatus) {
    StepStatus["Upcoming"] = "upcoming";
    StepStatus["Current"] = "current";
    StepStatus["Done"] = "done";
})(StepStatus || (StepStatus = {}));
var WrapperMobile = styled_components_browser_esm["default"].div(_templateObject1(), (0,es/* palette */.DG)("background"), (0,es/* palette */.DG)("black20"), dist.media.md(_templateObject()));
var WrapperDesktop = styled_components_browser_esm["default"].div(_templateObject3(), (0,es/* palette */.DG)("background"), (0,es/* palette */.DG)("black20"), dist.media.md(_templateObject2()));
var BarWrapper = styled_components_browser_esm["default"].div(_templateObject4());
// TODO: change to style.a when we resolve how to prevent user to go forward without completing a step
var Steps = styled_components_browser_esm["default"].div(_templateObject5());
var Step = styled_components_browser_esm["default"].div(_templateObject6(), (0,es/* switchProp */.db)("status", {
    upcoming: (0,es/* palette */.DG)("black20"),
    current: (0,es/* palette */.DG)("secondary"),
    done: (0,es/* palette */.DG)("black20")
}, (0,es/* palette */.DG)("black20")), (0,styles/* fluidRange */.S)("font-size", "16px", "18px"));
var Bar = styled_components_browser_esm["default"].div(_templateObject7(), (0,es/* palette */.DG)("red"), (0,es/* switchProp */.db)("stepIndex", {
    1: "calc(100% / 3)",
    2: "calc(100% * 2 / 3)",
    3: "100%",
    4: "100%"
}, "0"));
var CompleteIcon = styled_components_browser_esm["default"].div(_templateObject8(), (0,es/* palette */.DG)("success"));
var BackAnchor = styled_components_browser_esm["default"].a(_templateObject10(), dist.media.md(_templateObject9()));
var BackTxt = styled_components_browser_esm["default"].p(_templateObject11());
var steps = [
    CheckoutStep.Receiver,
    CheckoutStep.Delivery,
    CheckoutStep.Payment,
    CheckoutStep.Complete, 
];
var _obj;
var backBtnLabel = (_obj = {}, _defineProperty(_obj, CheckoutStep.Receiver, "Til baka \xed k\xf6rfu"), _defineProperty(_obj, CheckoutStep.Delivery, "Til baka \xed m\xf3ttakanda"), _defineProperty(_obj, CheckoutStep.Payment, "Til baka \xed afhendingarm\xe1ta"), _obj);
var _obj1;
var backBtnPath = (_obj1 = {}, _defineProperty(_obj1, CheckoutStep.Receiver, paths/* paths.cart */.H.cart), _defineProperty(_obj1, CheckoutStep.Delivery, paths/* paths.checkout */.H.checkout), _defineProperty(_obj1, CheckoutStep.Payment, paths/* paths.delivery */.H.delivery), _obj1);
var barSteps = [
    [
        paths/* paths.checkout */.H.checkout,
        "M\xf3ttakandi"
    ],
    [
        paths/* paths.delivery */.H.delivery,
        "Afhendingarm\xe1ti"
    ],
    [
        paths/* paths.payment */.H.payment,
        "Grei\xf0sla"
    ], 
];
function StatusBar(param) {
    var stepIndex = param.stepIndex;
    var getStatus = function getStatus(index) {
        if (index > stepIndex) {
            return StepStatus.Upcoming;
        }
        if (index < stepIndex) {
            return StepStatus.Done;
        }
        return StepStatus.Current;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {
                children: barSteps.map(function(step, i) {
                    return(// TODO: put Link back in when we resolve how to prevent user to go forward without completing a step
                    // <Link href={step[0]} key={i} passHref>
                    /* eslint-disable-next-line  react/no-array-index-key */ /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                        status: getStatus(i + 1),
                        children: [
                            step[1],
                            i + 1 < stepIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteIcon, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CheckLineIcon_default()), {
                                    size: 16,
                                    color: themes/* theme.palette.white */.r.palette.white
                                })
                            })
                        ]
                    }, i));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                stepIndex: stepIndex
            })
        ]
    });
}
function CheckoutStatusBar(param) {
    var step = param.step;
    var stepIndex = steps.indexOf(step) + 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperMobile, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusBar, {
                    stepIndex: stepIndex
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperDesktop, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                col: 1,
                                md: 3,
                                lg: 3.5,
                                children: !!backBtnLabel[step] && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: backBtnPath[step],
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackAnchor, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftLineIcon_default()), {
                                                color: themes/* theme.palette.red */.r.palette.red
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackTxt, {
                                                children: backBtnLabel[step]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                col: 10,
                                md: 6,
                                lg: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusBar, {
                                    stepIndex: stepIndex
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                col: 1,
                                md: 3,
                                lg: 3.5
                            })
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/context/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(76336);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/context/CheckoutContext/index.tsx + 15 modules
var CheckoutContext = __webpack_require__(86771);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/cart/CartOverview.tsx
var CartOverview = __webpack_require__(28027);
;// CONCATENATED MODULE: ./src/components/checkout/CheckoutPageWrapper.tsx










function CheckoutPageWrapper(param) {
    var step = param.step, children = param.children, title = param.title, paymentInProgress = param.paymentInProgress;
    var ref, ref1;
    var ref2 = (0,UserContext/* useUser */.aF)(), user = ref2.user, showLogin = ref2.showLogin;
    var ref3 = (0,CheckoutContext/* useCheckout */.Mg)(), checkout = ref3.checkout, checkoutLoading = ref3.checkoutLoading;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (!user && showLogin) {
            router.replace(paths/* paths.cart */.H.cart);
        }
    }, [
        router,
        showLogin,
        user
    ]);
    if (!checkoutLoading && !(checkout === null || checkout === void 0 ? void 0 : (ref = checkout.lines) === null || ref === void 0 ? void 0 : ref.length) && !paymentInProgress) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCart, {
            inCheckout: true
        });
    }
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutStatusBar, {
                step: step
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* SpacingWrapper */.$3, {
                spacing: 50,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                        title: title !== null && title !== void 0 ? title : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                        justifyContent: "between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                col: 12,
                                md: 7,
                                lg: 6,
                                children: children
                            }),
                            !checkoutLoading && !!(checkout === null || checkout === void 0 ? void 0 : (ref1 = checkout.lines) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                col: 12,
                                md: 4,
                                lg: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview/* default */.Z, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/remixicon-react/AddLineIcon.js
var AddLineIcon = __webpack_require__(69675);
var AddLineIcon_default = /*#__PURE__*/__webpack_require__.n(AddLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Building4LineIcon.js
var Building4LineIcon = __webpack_require__(64402);
var Building4LineIcon_default = /*#__PURE__*/__webpack_require__.n(Building4LineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/UserLineIcon.js
var UserLineIcon = __webpack_require__(12331);
var UserLineIcon_default = /*#__PURE__*/__webpack_require__.n(UserLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/BillLineIcon.js
var BillLineIcon = __webpack_require__(33901);
var BillLineIcon_default = /*#__PURE__*/__webpack_require__.n(BillLineIcon);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/utils/checkout.ts + 1 modules
var utils_checkout = __webpack_require__(97688);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/components/account/AddressForm.tsx
var AddressForm = __webpack_require__(77834);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/components/form/index.tsx + 3 modules
var components_form = __webpack_require__(27618);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(70148);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/utils/klaviyo.ts
var klaviyo = __webpack_require__(8600);
;// CONCATENATED MODULE: ./src/components/checkout/Receiver.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Receiver_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function Receiver_templateObject() {
    var data = Receiver_taggedTemplateLiteral([
        "\n      padding-left: 56px;\n    "
    ]);
    Receiver_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Receiver_templateObject1() {
    var data = Receiver_taggedTemplateLiteral([
        "\n  &.indent {\n    ",
        "\n  }\n"
    ]);
    Receiver_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

























var IndentWrapper = styled_components_browser_esm["default"].div(Receiver_templateObject1(), dist.media.md(Receiver_templateObject()));
function Receiver() {
    var ref18, ref1, ref2, ref3;
    var ref4 = (0,UserContext/* useUser */.aF)(), user = ref4.user, addressData = ref4.addressData, deleteAddress = ref4.deleteAddress, currCustomerAddresses = ref4.currCustomerAddresses, companyId = ref4.companyId;
    var ref5 = (0,CheckoutContext/* useCheckout */.Mg)(), checkout = ref5.checkout, updateCheckoutAddresses = ref5.updateCheckoutAddresses;
    var push = (0,next_router.useRouter)().push;
    var ref6 = (0,react.useState)(false), show = ref6[0], setShow = ref6[1];
    var ref7 = (0,react.useState)(false), showBillingForm = ref7[0], setShowBillingForm = ref7[1];
    var ref8 = (0,react.useState)(false), showDeleteModal = ref8[0], setShowDeleteModal = ref8[1];
    var ref9 = (0,react.useState)(), separateBilling = ref9[0], setSeparateBilling = ref9[1];
    var ref10 = (0,react.useState)(), addressToDelete = ref10[0], setAddressToDelete = ref10[1];
    var ref11 = (0,react.useState)(), selectedShippingAddress = ref11[0], setSelectedShippingAddress = ref11[1];
    var ref12 = (0,react.useState)(), selectedBillingAddress = ref12[0], setSelectedBillingAddress = ref12[1];
    var ref13 = (0,react.useState)(false), isLoading = ref13[0], setIsLoading = ref13[1];
    var addressesLeft = currCustomerAddresses === null || currCustomerAddresses === void 0 ? void 0 : currCustomerAddresses.filter(function(address) {
        return !(0,utils_checkout/* isSameAddress */.Wr)(address, selectedShippingAddress);
    });
    var shippingAddressExists = (0,utils_checkout/* AddressExists */.Ly)(currCustomerAddresses, checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress);
    var billingAddressExists = (0,utils_checkout/* AddressExists */.Ly)(currCustomerAddresses, checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress);
    var onToggleSeparateBilling = (0,react.useCallback)(function(nextState) {
        if (!nextState) {
            setSelectedBillingAddress(selectedShippingAddress);
            setSeparateBilling(!nextState);
        }
        setSeparateBilling(nextState);
        if (nextState && (addressesLeft === null || addressesLeft === void 0 ? void 0 : addressesLeft.length) === 1) {
            setSelectedBillingAddress(addressesLeft[0]);
        }
    }, [
        selectedShippingAddress,
        addressesLeft
    ]);
    // TODO: email update function not working, the post is 200 but the email doesn't update. Will hide for now.
    var onClickNext = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var shippingAddressErrors, billingAddressErrors;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    ;
                    // setErrors({email: ''})
                    setIsLoading(true);
                    if (!(!selectedShippingAddress || !selectedBillingAddress)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 5:
                    updateCheckoutAddresses((0,utils_checkout/* toAddressInput */.UU)(selectedShippingAddress), (0,utils_checkout/* toAddressInput */.UU)(selectedBillingAddress)).then(function(res) {
                        var ref, ref14, ref15, ref16;
                        var ref17;
                        shippingAddressErrors = (ref17 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref14 = ref.checkoutShippingAddressUpdate) === null || ref14 === void 0 ? void 0 : ref14.errors) !== null && ref17 !== void 0 ? ref17 : [];
                        billingAddressErrors = res === null || res === void 0 ? void 0 : (ref15 = res.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.checkoutBillingAddressUpdate) === null || ref16 === void 0 ? void 0 : ref16.errors;
                        if ((shippingAddressErrors === null || shippingAddressErrors === void 0 ? void 0 : shippingAddressErrors.length) || (billingAddressErrors === null || billingAddressErrors === void 0 ? void 0 : billingAddressErrors.length)) {
                            if ((0,lodash.isMatch)(shippingAddressErrors === null || shippingAddressErrors === void 0 ? void 0 : shippingAddressErrors[0], {
                                code: "INVALID",
                                field: "phone"
                            })) {
                                react_toastify_esm/* toast.error */.Am.error("\xd3gilt s\xedman\xfamer m\xf3ttakanda");
                            }
                            if ((billingAddressErrors === null || billingAddressErrors === void 0 ? void 0 : billingAddressErrors[0]) && (0,lodash.isMatch)(billingAddressErrors === null || billingAddressErrors === void 0 ? void 0 : billingAddressErrors[0], {
                                code: "INVALID",
                                field: "phone"
                            })) {
                                react_toastify_esm/* toast.error */.Am.error("\xd3gilt s\xedman\xfamer grei\xf0anda");
                            } else {
                                (0,CheckoutContext/* handleCheckoutError */.w4)(shippingAddressErrors);
                                (0,CheckoutContext/* handleCheckoutError */.w4)(billingAddressErrors);
                            }
                        }
                    });
                    setIsLoading(false);
                    if (!(shippingAddressErrors === null || shippingAddressErrors === void 0 ? void 0 : shippingAddressErrors.length) && !(billingAddressErrors === null || billingAddressErrors === void 0 ? void 0 : billingAddressErrors.length)) {
                        push(paths/* paths.delivery */.H.delivery);
                    }
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        updateCheckoutAddresses,
        selectedShippingAddress,
        selectedBillingAddress,
        push, 
    ]);
    var onDeleteAddress = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setIsLoading(true);
                    if (!(addressToDelete === null || addressToDelete === void 0 ? void 0 : addressToDelete.id)) {
                        _ctx.next = 4;
                        break;
                    }
                    _ctx.next = 4;
                    return deleteAddress(addressToDelete.id);
                case 4:
                    if ((0,utils_checkout/* isSameAddress */.Wr)(addressToDelete, selectedShippingAddress)) {
                        setSelectedShippingAddress(undefined);
                    }
                    setIsLoading(false);
                    setShowDeleteModal(false);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        deleteAddress,
        selectedShippingAddress,
        setSelectedShippingAddress,
        addressToDelete, 
    ]);
    var onAddShippingAddress = (0,react.useCallback)(function(address) {
        setSelectedShippingAddress(address);
        if (!separateBilling) {
            setSelectedBillingAddress(address);
        }
    }, [
        setSelectedShippingAddress,
        setSelectedBillingAddress,
        separateBilling
    ]);
    var onAddBillingAddress = (0,react.useCallback)(function(address) {
        setSelectedBillingAddress(address);
    }, [
        setSelectedBillingAddress
    ]);
    (0,react.useEffect)(function() {
        // Setting initial state
        if (checkout && separateBilling === undefined) {
            if (shippingAddressExists && billingAddressExists) {
                setSeparateBilling(!(0,utils_checkout/* isSameAddress */.Wr)(checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress, checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress));
            }
            if (shippingAddressExists && (checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress)) {
                setSelectedShippingAddress(checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress);
            }
            if (billingAddressExists && (checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress)) {
                setSelectedBillingAddress(checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress);
            }
            if ((currCustomerAddresses === null || currCustomerAddresses === void 0 ? void 0 : currCustomerAddresses.length) === 1) {
                setSelectedShippingAddress(currCustomerAddresses === null || currCustomerAddresses === void 0 ? void 0 : currCustomerAddresses[0]);
                setSelectedBillingAddress(currCustomerAddresses === null || currCustomerAddresses === void 0 ? void 0 : currCustomerAddresses[0]);
            }
        }
    }, [
        checkout,
        separateBilling,
        shippingAddressExists,
        billingAddressExists,
        currCustomerAddresses, 
    ]);
    (0,react.useEffect)(function() {
        // Turn off separate billing when shipping address is changed
        if (selectedShippingAddress && (0,lodash.isEqual)(selectedShippingAddress, selectedBillingAddress)) {
            setSeparateBilling(false);
        }
    }, [
        selectedShippingAddress,
        selectedBillingAddress
    ]);
    (0,react.useEffect)(function() {
        if (user && checkout) {
            var ref, ref19;
            (0,klaviyo/* trackStartedCheckout */.kL)(user, checkout === null || checkout === void 0 ? void 0 : checkout.lines, checkout === null || checkout === void 0 ? void 0 : (ref = checkout.totalPrice) === null || ref === void 0 ? void 0 : (ref19 = ref.gross) === null || ref19 === void 0 ? void 0 : ref19.amount);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* SpacingWrapper */.$3, {
                spacing: 24,
                children: [
                    currCustomerAddresses === null || currCustomerAddresses === void 0 ? void 0 : currCustomerAddresses.map(function(address) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiverCard, {
                            address: address,
                            selected: (0,lodash.isEqual)(address, selectedShippingAddress),
                            onSelect: function() {
                                setSelectedShippingAddress(address);
                                if (!separateBilling) {
                                    setSelectedBillingAddress(address);
                                }
                            },
                            onDelete: function() {
                                setShowDeleteModal(true);
                                setAddressToDelete(address);
                            },
                            cornerButton: !companyId,
                            icon: companyId ? /*#__PURE__*/ (0,jsx_runtime.jsx)((Building4LineIcon_default()), {
                                size: 30,
                                color: themes/* theme.palette.red */.r.palette.red
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((UserLineIcon_default()), {
                                size: 30,
                                color: themes/* theme.palette.primary */.r.palette.primary
                            })
                        }, address.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Modal */.u_, {
                        width: "800px",
                        setShow: setShow,
                        show: show,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm/* default */.ZP, {
                            formTitle: "M\xf3ttakandi",
                            firstName: "",
                            lastName: "",
                            phone: "",
                            streetAddress1: "",
                            city: "",
                            postalCode: "",
                            setShow: setShow,
                            handleAddAddress: onAddShippingAddress
                        })
                    }),
                    !companyId && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndentWrapper, {
                        className: classnames_default()({
                            indent: !!(addressData === null || addressData === void 0 ? void 0 : (ref18 = addressData.me) === null || ref18 === void 0 ? void 0 : (ref1 = ref18.addresses) === null || ref1 === void 0 ? void 0 : ref1.length)
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* UnderlineButton */.tg, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((AddLineIcon_default()), {
                                color: themes/* theme.palette.primary */.r.palette.primary
                            }),
                            text: "N\xfdr m\xf3ttakandi",
                            onClick: function() {
                                return setShow(true);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* SpacingWrapper */.$3, {
                spacing: 50,
                children: [
                    !companyId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                                title: "Grei\xf0andi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* Toggle */.ZD, {
                                label: "Grei\xf0andi er annar en m\xf3ttakandi",
                                color: "primary",
                                checked: separateBilling,
                                onToggle: onToggleSeparateBilling,
                                withGutter: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                                spacing: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Expandable */.Ak, {
                                    expanded: separateBilling,
                                    children: [
                                        addressesLeft === null || addressesLeft === void 0 ? void 0 : addressesLeft.map(function(address) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiverCard, {
                                                address: address,
                                                selected: (0,utils_checkout/* isSameAddress */.Wr)(address, selectedBillingAddress),
                                                onSelect: function() {
                                                    return setSelectedBillingAddress(address);
                                                },
                                                onDelete: function() {
                                                    setShowDeleteModal(true);
                                                    setAddressToDelete(address);
                                                },
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((BillLineIcon_default()), {
                                                    size: 30,
                                                    color: themes/* theme.palette.primary */.r.palette.primary
                                                })
                                            }, address.id);
                                        }),
                                        !(addressesLeft === null || addressesLeft === void 0 ? void 0 : addressesLeft.length) && companyId && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                                            withGutter: true,
                                            children: "\xdea\xf0 er ekki h\xe6gt a\xf0 velja annan grei\xf0anda fyrir \xfeetta fyrirt\xe6ki!"
                                        }),
                                        !companyId && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndentWrapper, {
                                            className: classnames_default()({
                                                indent: !!(addressesLeft === null || addressesLeft === void 0 ? void 0 : addressesLeft.length)
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* UnderlineButton */.tg, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((AddLineIcon_default()), {
                                                    color: themes/* theme.palette.primary */.r.palette.primary
                                                }),
                                                text: "N\xfdr grei\xf0andi",
                                                onClick: function() {
                                                    return setShowBillingForm(true);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Modal */.u_, {
                                            width: "800px",
                                            setShow: setShowBillingForm,
                                            show: showBillingForm,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm/* default */.ZP, {
                                                formTitle: "Grei\xf0andi",
                                                firstName: "",
                                                lastName: "",
                                                phone: "",
                                                streetAddress1: "",
                                                city: "",
                                                postalCode: "",
                                                setShow: setShowBillingForm,
                                                handleAddAddress: onAddBillingAddress
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IndentWrapper, {
                        className: classnames_default()({
                            indent: separateBilling && !!(addressData === null || addressData === void 0 ? void 0 : (ref2 = addressData.me) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.addresses) === null || ref3 === void 0 ? void 0 : ref3.length) && !!(addressesLeft === null || addressesLeft === void 0 ? void 0 : addressesLeft.length)
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                            withGutter: true,
                            color: "secondary",
                            outlined: true,
                            loading: isLoading,
                            disabled: !selectedShippingAddress || !selectedBillingAddress || separateBilling && (0,utils_checkout/* isSameAddress */.Wr)(selectedShippingAddress, selectedBillingAddress),
                            onClick: onClickNext,
                            children: "\xc1fram"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Modal */.u_, {
                show: showDeleteModal,
                setShow: setShowDeleteModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DeleteConfirmation */.L3, {
                    title: "Ertu viss um a\xf0 \xfe\xfa viljir ey\xf0a uppl\xfdsingunum?",
                    text: "\xde\xfa munt ekki geta teki\xf0 \xfeessa a\xf0ger\xf0 til baka.",
                    onCancel: function() {
                        return setShowDeleteModal(false);
                    },
                    onRemove: onDeleteAddress,
                    cancelText: "H\xe6tta vi\xf0",
                    submitText: "Ey\xf0a"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/kennitala/dist/kennitala.min.js
var kennitala_min = __webpack_require__(61473);
// EXTERNAL MODULE: ./src/components/account/InfoCard.tsx
var InfoCard = __webpack_require__(65260);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(8597);
;// CONCATENATED MODULE: ./src/components/checkout/ReceiverCard.tsx
function ReceiverCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ReceiverCard_templateObject() {
    var data = ReceiverCard_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    ReceiverCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReceiverCard_templateObject1() {
    var data = ReceiverCard_taggedTemplateLiteral([
        "\n    width: 56px;\n    min-width: 56px;\n    display: flex;\n  "
    ]);
    ReceiverCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReceiverCard_templateObject2() {
    var data = ReceiverCard_taggedTemplateLiteral([
        "\n  width: 40px;\n  min-width: 40px;\n  display: none;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    ReceiverCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var Wrapper = styled_components_browser_esm["default"].div(ReceiverCard_templateObject());
var RadioContainer = styled_components_browser_esm["default"].div(ReceiverCard_templateObject2(), dist.media.md(ReceiverCard_templateObject1()));
function ReceiverCard(param) {
    var address = param.address, selected = param.selected, onSelect = param.onSelect, onDelete = param.onDelete, cornerButton = param.cornerButton, icon = param.icon;
    var firstName = address.firstName, lastName = address.lastName, streetAddress1 = address.streetAddress1, postalCode = address.postalCode, city = address.city, phone = address.phone, companyName = address.companyName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* RadioButton */.EU, {
                    checked: selected,
                    onChange: onSelect
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoCard/* default */.Z, {
                icon: icon,
                selected: selected,
                onSelect: onSelect,
                deleteIcon: true,
                title: firstName || companyName,
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                            children: lastName && (0,kennitala_min.format)(lastName)
                        }),
                        phone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                            children: (0,strings/* formatPhoneNumber */.un)(phone)
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                            children: [
                                streetAddress1,
                                ","
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                            children: [
                                postalCode,
                                " ",
                                city
                            ]
                        })
                    ]
                }),
                cornerButton: cornerButton,
                handleDelete: onDelete,
                pointerCursor: true
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/TruckLineIcon.js
var TruckLineIcon = __webpack_require__(67389);
var TruckLineIcon_default = /*#__PURE__*/__webpack_require__.n(TruckLineIcon);
// EXTERNAL MODULE: ./src/utils/numbers.ts
var numbers = __webpack_require__(60165);
// EXTERNAL MODULE: ./src/api/rest/index.ts + 6 modules
var rest = __webpack_require__(73565);
// EXTERNAL MODULE: ./src/utils/isNotNull.ts
var isNotNull = __webpack_require__(84403);
// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(46550);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
// EXTERNAL MODULE: ./src/components/common/Loader.tsx
var Loader = __webpack_require__(965);
// EXTERNAL MODULE: ./src/components/account/ordersOverview.tsx
var ordersOverview = __webpack_require__(73823);
;// CONCATENATED MODULE: ./src/components/checkout/CheckoutRadioCard.tsx
function CheckoutRadioCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CheckoutRadioCard_templateObject() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    CheckoutRadioCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject1() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n    padding: 34px;\n  "
    ]);
    CheckoutRadioCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject2() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 15px 15px 15px 15px;\n  cursor: pointer;\n\n  ",
        "\n\n  margin: 16px 0;\n  width: 100%;\n  max-width: 700px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  &.selected {\n    border: 1px solid ",
        ";\n  }\n\n  .btn-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: black;\n    padding: 12px;\n    .close_btn {\n      color: white;\n    }\n    margin-top: 16px;\n    &.selected {\n      background-color: white;\n      border: 1px solid black;\n      .map-btn,\n      .close_btn {\n        color: black;\n        background-color: white;\n      }\n    }\n  }\n\n  .map-btn {\n    font-size: 1.125rem;\n    outline: none;\n    border: none;\n    background-color: black;\n    color: white;\n    font-weight: 700;\n    cursor: pointer;\n    &:hover {\n      transition: none;\n    }\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n"
    ]);
    CheckoutRadioCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject3() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n    width: 56px;\n    min-width: 56px;\n    display: flex;\n  "
    ]);
    CheckoutRadioCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject4() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n  width: 40px;\n  min-width: 40px;\n  display: none;\n  align-items: center;\n  ",
        "\n"
    ]);
    CheckoutRadioCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject5() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  @media screen and (max-width: ",
        ") {\n    display: block;\n  }\n"
    ]);
    CheckoutRadioCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject6() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n    padding-right: 50px;\n  "
    ]);
    CheckoutRadioCard_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject7() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n  padding-right: 24px;\n\n  ",
        "\n"
    ]);
    CheckoutRadioCard_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject8() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        ""
    ]);
    CheckoutRadioCard_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject9() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        ""
    ]);
    CheckoutRadioCard_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject10() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n    padding-left: 80px;\n  "
    ]);
    CheckoutRadioCard_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function CheckoutRadioCard_templateObject11() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n  padding-top: 16px;\n  padding-left: 54px;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    CheckoutRadioCard_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = CheckoutRadioCard_taggedTemplateLiteral([
        "\n  position: relative;\n  /* margin: 20px 0; */\n  border-radius: 0;\n  border: 1px solid black;\n  @media screen and (max-width: ",
        ") {\n    min-width: 100%;\n    .sort-button {\n      min-width: 100%;\n    }\n  }\n  .options {\n    position: absolute;\n    top: 120%;\n    border: 1px solid black;\n    padding: 10px;\n    border-left: 1px solid black !important;\n    border-bottom: 1px solid black !important;\n    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}

/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable @typescript-eslint/no-use-before-define */ /* eslint-disable unused-imports/no-unused-vars */ /* eslint-disable @typescript-eslint/no-explicit-any */ 











var CheckoutRadioCard_Wrapper = styled_components_browser_esm["default"].div(CheckoutRadioCard_templateObject());
var Card = styled_components_browser_esm["default"].div(CheckoutRadioCard_templateObject2(), dist.media.md(CheckoutRadioCard_templateObject1()), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("red"));
var CheckoutRadioCard_RadioContainer = styled_components_browser_esm["default"].div(CheckoutRadioCard_templateObject4(), dist.media.md(CheckoutRadioCard_templateObject3()));
var CardHead = styled_components_browser_esm["default"].div(CheckoutRadioCard_templateObject5(), themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM);
var IconContainer = styled_components_browser_esm["default"].div(CheckoutRadioCard_templateObject7(), dist.media.md(CheckoutRadioCard_templateObject6()));
var TextContainer = styled_components_browser_esm["default"].div(CheckoutRadioCard_templateObject8());
var Description = styled_components_browser_esm["default"].div(CheckoutRadioCard_templateObject9());
var CardOptions = styled_components_browser_esm["default"].div(CheckoutRadioCard_templateObject11(), dist.media.md(CheckoutRadioCard_templateObject10()));
var SortDropDown = (0,styled_components_browser_esm["default"])(ordersOverview/* SortDropdown */.a)(_templateObject12(), themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM);
function CheckoutRadioCard(param) {
    var title = param.title, description = param.description, price = param.price, _selected = param.selected, selected = _selected === void 0 ? false : _selected, onSelect = param.onSelect, icon = param.icon, children = param.children, showDropDown = param.showDropDown, options = param.options, droppDelivery = param.droppDelivery, droppDeliveryId = param.droppDeliveryId, locationId = param.locationId, mapDetail = param.mapDetail, setLocationInfo = param.setLocationInfo, updateDropDownLocationInfo = param.updateDropDownLocationInfo, setSelectedDropLocation = param.setSelectedDropLocation;
    var ref = (0,react.useState)(0), optionNum = ref[0], setOptionNum = ref[1];
    var ref1 = (0,react.useState)(null), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var ref2 = (0,react.useState)(false), mapSelected = ref2[0], setMapSelected = ref2[1];
    var ref3 = (0,react.useState)(""), selectedMapAddress = ref3[0], setSelectedMapAddress = ref3[1];
    (0,react.useEffect)(function() {
        if (options && options.length > 0 && optionNum === 0) {
            setSelectedOption(options[0]);
            setOptionNum(function(n) {
                return n + 1;
            });
        }
    }, [
        optionNum,
        options
    ]);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var getDetailsFromMapSelection = function() {
        if ( true && typeof window.chooseDroppLocation === "function") {
            // DroppBoxAPI function to get details from map selection.
            window.chooseDroppLocation().then(function(location) {
                if (location && location.name && location.id) {
                    var parsedValues = {
                        droppboxName: location.name,
                        droppboxId: location.id,
                        droppboxLatitude: location.gpsLatitude,
                        droppboxLongitude: location.gpsLongitude,
                        droppboxAddress: location.address
                    };
                    if (locationId) {
                        locationId(location);
                    }
                    if (setLocationInfo) {
                        setLocationInfo(parsedValues);
                    }
                    setSelectedMapAddress(location.address);
                    setMapSelected(true);
                } else {
                    console.error("Invalid location data:", location);
                }
            }).catch(function(err) {
                console.log("Got error on map view function --> ".concat(err));
            });
        }
    };
    var handleOptionClick = function(option) {
        setSelectedOption(option);
        setShowDropdown(false);
        if (locationId) {
            locationId(option);
        }
    };
    var ref4 = (0,react.useState)(false), showDropdown = ref4[0], setShowDropdown = ref4[1];
    var dropDownRef = (0,react.useRef)(null);
    var closeMap = (0,react.useCallback)(function() {
        if (!locationId) return;
        setMapSelected(false);
        setSelectedMapAddress("");
        setSelectedOption(options[0]);
        locationId(options[0]);
    }, [
        locationId,
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutRadioCard_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutRadioCard_RadioContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* RadioButton */.EU, {
                    checked: selected,
                    onChange: onSelect
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                className: classnames_default()({
                    selected: selected
                }),
                onClick: onSelect,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHead, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                children: icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Title6 */.L8, {
                                        withGutter: true,
                                        children: [
                                            title,
                                            " ",
                                            price && "- ".concat(price)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                        children: description
                                    }),
                                    showDropDown && options && !mapSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: options.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortDropDown, {
                                            ref: dropDownRef,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "sort-button",
                                                    onClick: function() {
                                                        return setShowDropdown(!showDropdown);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.address
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: showDropdown ? "arrow up" : "arrow down"
                                                        })
                                                    ]
                                                }),
                                                showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "options",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: options === null || options === void 0 ? void 0 : options.map(function(option, index) {
                                                            return index <= 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: function() {
                                                                        return handleOptionClick(option);
                                                                    },
                                                                    children: option === null || option === void 0 ? void 0 : option.address
                                                                })
                                                            }, option.id) : null;
                                                        })
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                    }),
                                    mapDetail && options && showDropDown && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "btn-container ".concat(mapSelected && "selected"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                onClick: getDetailsFromMapSelection,
                                                className: "map-btn",
                                                children: selectedMapAddress || "Velja annan afhendingarsta\xf0"
                                            }),
                                            mapSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "close_btn",
                                                onClick: closeMap,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !!children && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Expandable */.Ak, {
                        expanded: selected,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardOptions, {
                            children: children
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/form/Input.tsx
var form_Input = __webpack_require__(92469);
;// CONCATENATED MODULE: ./src/components/checkout/DeliveryNote.tsx
function DeliveryNote_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DeliveryNote_templateObject() {
    var data = DeliveryNote_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  position: relative;\n"
    ]);
    DeliveryNote_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NoteWrapper = styled_components_browser_esm["default"].div(DeliveryNote_templateObject());
var DeliveryNote = function(param) {
    var value = param.value, setValue = param.setValue;
    var handleChange = (0,react.useCallback)(function(event) {
        setValue(event.target.value);
    }, [
        setValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_Input/* Input */.II, {
            label: "Athugasemd",
            withGutter: true,
            onChange: handleChange,
            type: "textarea",
            defaultValue: value !== null && value !== void 0 ? value : "",
            valid: true,
            maxLength: 50,
            charCount: value === null || value === void 0 ? void 0 : value.length,
            showCharCount: true
        })
    });
};

;// CONCATENATED MODULE: ./src/components/cart/CartShipmentPricingAlert.tsx
function CartShipmentPricingAlert_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CartShipmentPricingAlert_templateObject() {
    var data = CartShipmentPricingAlert_taggedTemplateLiteral([
        "\n  margin: 16px 0;\n"
    ]);
    CartShipmentPricingAlert_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartShipmentPricingAlert_templateObject1() {
    var data = CartShipmentPricingAlert_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  flex-wrap: wrap;\n\n  svg {\n    margin-right: 16px;\n    margin-bottom: 6px;\n  }\n"
    ]);
    CartShipmentPricingAlert_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var CartShipmentPricingAlert_Wrapper = styled_components_browser_esm["default"].div(CartShipmentPricingAlert_templateObject());
var Content = styled_components_browser_esm["default"].div(CartShipmentPricingAlert_templateObject1());
var shippingLabel = "Sendingarkostna\xf0ur fellur ni\xf0ur ef \xfe\xfa b\xe6tir v\xf6rum \xed k\xf6rfuna fyrir";
var freeShippingLabel = "Fr\xedr sendingarkostna\xf0ur virkja\xf0ur!";
var CartShipmentPricingAlert = function(param) {
    var shipmentPricingThreshold = param.shipmentPricingThreshold;
    var ref, ref1;
    var checkout = (0,CheckoutContext/* useCheckout */.Mg)().checkout;
    var ref2 = (0,react.useState)(true), isOpen = ref2[0], setIsOpen = ref2[1];
    var totalProdPrice = checkout === null || checkout === void 0 ? void 0 : (ref = checkout.subtotalPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.amount;
    var isActivatedFreeShipping = shipmentPricingThreshold && totalProdPrice && totalProdPrice > shipmentPricingThreshold;
    var amountNeeded = shipmentPricingThreshold && shipmentPricingThreshold - (totalProdPrice !== null && totalProdPrice !== void 0 ? totalProdPrice : 0);
    (0,react.useEffect)(function() {
        if (!isOpen && isActivatedFreeShipping) {
            setIsOpen(true);
        }
    }, [
        isOpen,
        isActivatedFreeShipping
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shipmentPricingThreshold && amountNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartShipmentPricingAlert_Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Alert */.bZ, {
                type: !isActivatedFreeShipping ? "warning" : "success",
                open: isOpen,
                setOpen: setIsOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((TruckLineIcon_default()), {
                            color: !isActivatedFreeShipping ? themes/* theme.palette.warning */.r.palette.warning : themes/* theme.palette.success */.r.palette.success,
                            size: 24
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                            children: [
                                !isActivatedFreeShipping ? shippingLabel : freeShippingLabel,
                                " ",
                                !isActivatedFreeShipping && /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        (0,numbers/* formatNumber */.uf)(amountNeeded),
                                        " kr."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/Delivery.tsx
/* provided dependency */ var process = __webpack_require__(34155);
function Delivery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Delivery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Delivery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Delivery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Delivery_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function Delivery_templateObject() {
    var data = Delivery_taggedTemplateLiteral([
        "\n    padding-left: 56px;\n  "
    ]);
    Delivery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Delivery_templateObject1() {
    var data = Delivery_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    Delivery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* eslint-disable no-nested-ternary */ /* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
















var ref, ref1;
var droppMethodId = (process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : "U2hpcHBpbmdNZXRob2Q6MjA=") || "";
var droppDelMethodId = (process === null || process === void 0 ? void 0 : (ref1 = process.env) === null || ref1 === void 0 ? void 0 : "U2hpcHBpbmdNZXRob2Q6MTk=") || "";
var Delivery_IndentWrapper = styled_components_browser_esm["default"].div(Delivery_templateObject1(), dist.media.md(Delivery_templateObject()));
function Delivery() {
    var ref11 = (0,CheckoutContext/* useCheckout */.Mg)(), updateShippingMethod = ref11.updateShippingMethod, checkout = ref11.checkout, prepareOrderCreate = ref11.prepareOrderCreate, prepareDroppOrderCreate = ref11.prepareDroppOrderCreate;
    var push = (0,next_router.useRouter)().push;
    var ref2 = (0,react.useContext)(CheckoutContext/* CheckoutContext */.mN) || {}, locationId = ref2.locationId, extLocationId = ref2.extLocationId, updateLocationId = ref2.updateLocationId;
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(), selectedShippingId = ref4[0], setSelectedShippingId = ref4[1];
    var ref5 = (0,react.useState)(checkout ? checkout.note : ""), note = ref5[0], setNote = ref5[1];
    var ref6 = (0,react.useState)(), shippingCost = ref6[0], setShippingCost = ref6[1];
    var ref7 = (0,react.useState)([]), droppLocations = ref7[0], setDroppLocations = ref7[1];
    var ref8 = (0,react.useState)([]), droppDeliveryLocations = ref8[0], setDroppDeliveryLocations = ref8[1];
    var ref9 = (0,react.useState)(""), locationInfo = ref9[0], setLocationInfo = ref9[1];
    var ref10 = (0,react.useState)(checkout === null || checkout === void 0 ? void 0 : checkout.availableShippingMethods), availableShippingMethods = ref10[0], setAvailableShippingMethods = ref10[1];
    (0,react.useEffect)(function() {
        var ref12;
        var droppNotAvailable = checkout === null || checkout === void 0 ? void 0 : (ref12 = checkout.lines) === null || ref12 === void 0 ? void 0 : ref12.filter(function(prod) {
            return prod === null || prod === void 0 ? void 0 : prod.variant.product.metadata.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.key) === "has_no_dropp_shipping" && (item === null || item === void 0 ? void 0 : item.value) === "true";
            });
        });
        if (droppNotAvailable.length > 0) {
            setAvailableShippingMethods(function() {
                return availableShippingMethods.filter(function(method) {
                    return method.id !== droppMethodId && method.id !== droppDelMethodId;
                });
            });
        }
    }, [
        checkout
    ]);
    var setLocationIdInfo = function(location) {
        if (updateLocationId) {
            updateLocationId(location);
        }
    };
    var onClickNext = (0,react.useCallback)(Delivery_asyncToGenerator(runtime_default().mark(function _callee() {
        var noteJsonString;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setIsLoading(true);
                    if (selectedShippingId) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    if (!note) {
                        _ctx.next = 7;
                        break;
                    }
                    noteJsonString = {
                        note: note,
                        locationInfo: locationInfo,
                        // locationId,
                        method: selectedShippingId === droppMethodId || selectedShippingId === droppDelMethodId ? locationInfo : ""
                    };
                    _ctx.next = 7;
                    return prepareOrderCreate(JSON.stringify(noteJsonString));
                case 7:
                    if (!(extLocationId && (selectedShippingId === droppMethodId || selectedShippingId === droppDelMethodId))) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 10;
                    return prepareDroppOrderCreate(JSON.stringify({
                        location: extLocationId
                    }));
                case 10:
                    updateShippingMethod(selectedShippingId).then(function(res) {
                        var ref14, ref13;
                        var errors = res === null || res === void 0 ? void 0 : (ref14 = res.data) === null || ref14 === void 0 ? void 0 : (ref13 = ref14.checkoutShippingMethodUpdate) === null || ref13 === void 0 ? void 0 : ref13.errors;
                        if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                            push(paths/* paths.payment */.H.payment);
                            setIsLoading(false);
                        } else {
                            (0,CheckoutContext/* handleCheckoutError */.w4)(errors);
                            setIsLoading(false);
                        }
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        note,
        updateShippingMethod,
        selectedShippingId,
        prepareOrderCreate,
        prepareDroppOrderCreate,
        push,
        locationInfo,
        extLocationId, 
    ]);
    var getLocations = (0,react.useCallback)(Delivery_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref16, ref15, postalCode, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!(checkout === null || checkout === void 0 ? void 0 : (ref16 = checkout.shippingAddress) === null || ref16 === void 0 ? void 0 : ref16.postalCode)) {
                        _ctx.next = 14;
                        break;
                    }
                    ;
                    postalCode = checkout === null || checkout === void 0 ? void 0 : (ref15 = checkout.shippingAddress) === null || ref15 === void 0 ? void 0 : ref15.postalCode;
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return rest/* restApi.fetchDroppLocations */._O.fetchDroppLocations(postalCode);
                case 7:
                    data = _ctx.sent.data;
                    if ((data === null || data === void 0 ? void 0 : data.locations) && postalCode) {
                        setDroppLocations(data.locations);
                    }
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    console.log("error", _ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ]
        ]);
    })), []);
    var getDeliveryLocations = (0,react.useCallback)(function() {
        var ref18;
        if (checkout === null || checkout === void 0 ? void 0 : (ref18 = checkout.shippingAddress) === null || ref18 === void 0 ? void 0 : ref18.postalCode) {
            var ref17;
            var postalCode = checkout === null || checkout === void 0 ? void 0 : (ref17 = checkout.shippingAddress) === null || ref17 === void 0 ? void 0 : ref17.postalCode;
            rest/* restApi.fetchDroppDeliveryLocations */._O.fetchDroppDeliveryLocations(postalCode).then(function(param) {
                var data = param.data;
                if (data === null || data === void 0 ? void 0 : data.codes) {
                    setDroppDeliveryLocations(data === null || data === void 0 ? void 0 : data.codes.map(function(code) {
                        return code.code;
                    }));
                }
            }).catch(function(err) {
                console.log("error", err);
                return false;
            });
        }
        return [];
    }, []);
    (0,react.useEffect)(function() {
        getLocations();
        getDeliveryLocations();
    }, [
        getDeliveryLocations,
        getLocations
    ]);
    (0,react.useEffect)(function() {
        var ref19;
        var methodId = checkout === null || checkout === void 0 ? void 0 : (ref19 = checkout.shippingMethod) === null || ref19 === void 0 ? void 0 : ref19.id;
        if (checkout && methodId === droppMethodId) {
            getLocations();
        }
    }, [
        checkout,
        getLocations
    ]);
    (0,react.useEffect)(function() {
        var availableMethods = checkout === null || checkout === void 0 ? void 0 : checkout.availableShippingMethods;
        if (selectedShippingId === droppMethodId) {
            setShippingCost(null);
        } else if (selectedShippingId === droppDelMethodId) {
            setShippingCost(null);
        } else if (checkout === null || checkout === void 0 ? void 0 : checkout.availableShippingMethods) {
            var ref20;
            var rules = availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.find(function(method) {
                var ref22;
                return method === null || method === void 0 ? void 0 : (ref22 = method.postalCodeRules) === null || ref22 === void 0 ? void 0 : ref22.length;
            });
            rules === null || rules === void 0 ? void 0 : (ref20 = rules.postalCodeRules) === null || ref20 === void 0 ? void 0 : ref20.map(function(rule) {
                var ref25, ref23, ref24;
                if ((checkout === null || checkout === void 0 ? void 0 : (ref25 = checkout.shippingAddress) === null || ref25 === void 0 ? void 0 : ref25.postalCode) && (checkout === null || checkout === void 0 ? void 0 : (ref23 = checkout.shippingAddress) === null || ref23 === void 0 ? void 0 : ref23.postalCode) <= rule.end && (checkout === null || checkout === void 0 ? void 0 : (ref24 = checkout.shippingAddress) === null || ref24 === void 0 ? void 0 : ref24.postalCode) >= rule.start) {
                    setShippingCost(function() {
                        var ref27, ref26;
                        return rules.maximumOrderPrice === null ? (ref27 = rules.minimumOrderPrice) === null || ref27 === void 0 ? void 0 : ref27.amount : (ref26 = rules.maximumOrderPrice) === null || ref26 === void 0 ? void 0 : ref26.amount;
                    });
                }
                return null;
            }, []);
        }
    }, [
        checkout,
        selectedShippingId
    ]);
    (0,react.useEffect)(function() {
        if (!locationId && droppLocations && droppLocations.length && updateLocationId) {
            updateLocationId(droppLocations[0]);
        }
    }, [
        droppLocations,
        locationId,
        updateLocationId
    ]);
    var changeShippingMethod = function(shippingId) {
        setSelectedShippingId(shippingId);
        getLocations();
        if (updateLocationId && shippingId === droppDelMethodId) {
            updateLocationId("9ec1f30c-2564-4b73-8954-25b7b3186ed3");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartShipmentPricingAlert, {
                shipmentPricingThreshold: shippingCost
            }),
            availableShippingMethods === null || availableShippingMethods === void 0 ? void 0 : availableShippingMethods.filter(isNotNull/* isNotNull */.K).map(function(sm) {
                var ref46, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45;
                return sm.id === droppMethodId ? droppLocations && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutRadioCard, {
                    title: sm.name,
                    price: ((ref46 = sm.price) === null || ref46 === void 0 ? void 0 : ref46.amount) ? "".concat((0,numbers/* formatNumber */.uf)((ref28 = sm.price) === null || ref28 === void 0 ? void 0 : ref28.amount), " kr.") : "",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((TruckLineIcon_default()), {
                        size: 30,
                        color: themes/* theme.palette.primary */.r.palette.primary
                    }),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                        children: (ref29 = JSON.parse(sm.description)) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.blocks) === null || ref30 === void 0 ? void 0 : (ref31 = ref30[0]) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.data) === null || ref32 === void 0 ? void 0 : ref32.text
                    }),
                    selected: selectedShippingId === sm.id,
                    onSelect: function() {
                        return changeShippingMethod(sm.id);
                    },
                    showDropDown: sm.id === droppMethodId,
                    options: droppLocations,
                    mapDetail: true,
                    droppDelivery: sm.id === droppMethodId,
                    droppDeliveryId: sm.id === droppMethodId ? sm.id : "",
                    locationId: setLocationIdInfo,
                    setLocationInfo: setLocationInfo
                }, sm.id) : sm.id === droppDelMethodId && checkout && droppDeliveryLocations.includes(Number(checkout === null || checkout === void 0 ? void 0 : (ref33 = checkout.shippingAddress) === null || ref33 === void 0 ? void 0 : ref33.postalCode)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutRadioCard, {
                    title: sm.name,
                    price: ((ref34 = sm.price) === null || ref34 === void 0 ? void 0 : ref34.amount) ? "".concat((0,numbers/* formatNumber */.uf)((ref35 = sm.price) === null || ref35 === void 0 ? void 0 : ref35.amount), " kr.") : "",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((TruckLineIcon_default()), {
                        size: 30,
                        color: themes/* theme.palette.primary */.r.palette.primary
                    }),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                        children: (ref36 = JSON.parse(sm.description)) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.blocks) === null || ref37 === void 0 ? void 0 : (ref38 = ref37[0]) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.data) === null || ref39 === void 0 ? void 0 : ref39.text
                    }),
                    selected: selectedShippingId === sm.id,
                    onSelect: function() {
                        return changeShippingMethod(sm.id);
                    },
                    options: droppLocations,
                    droppDelivery: sm.id === droppDelMethodId,
                    droppDeliveryId: sm.id === droppDelMethodId ? sm.id : "",
                    locationId: setLocationIdInfo
                }, sm.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutRadioCard, {
                    title: sm.name,
                    price: ((ref40 = sm.price) === null || ref40 === void 0 ? void 0 : ref40.amount) ? "".concat((0,numbers/* formatNumber */.uf)((ref41 = sm.price) === null || ref41 === void 0 ? void 0 : ref41.amount), " kr.") : "",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((TruckLineIcon_default()), {
                        size: 30,
                        color: themes/* theme.palette.primary */.r.palette.primary
                    }),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                        children: (ref42 = JSON.parse(sm.description)) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.blocks) === null || ref43 === void 0 ? void 0 : (ref44 = ref43[0]) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.data) === null || ref45 === void 0 ? void 0 : ref45.text
                    }),
                    selected: selectedShippingId === sm.id,
                    onSelect: function() {
                        return changeShippingMethod(sm.id);
                    }
                }, sm.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Delivery_IndentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryNote, {
                        value: note,
                        setValue: setNote
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                        spacing: 36,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                            withGutter: true,
                            color: "secondary",
                            outlined: true,
                            loading: isLoading,
                            disabled: !selectedShippingId,
                            onClick: onClickNext,
                            children: "\xc1fram"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/BankCardLineIcon.js
var BankCardLineIcon = __webpack_require__(44165);
var BankCardLineIcon_default = /*#__PURE__*/__webpack_require__.n(BankCardLineIcon);
// EXTERNAL MODULE: ./src/constants/index.ts + 1 modules
var constants = __webpack_require__(31115);
;// CONCATENATED MODULE: ./src/components/checkout/CreditCardFormFields.tsx
function CreditCardFormFields_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CreditCardFormFields_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CreditCardFormFields_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CreditCardFormFields_templateObject() {
    var data = CreditCardFormFields_taggedTemplateLiteral([
        "\n  margin-top: 32px;\n"
    ]);
    CreditCardFormFields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CheckboxWrapper = styled_components_browser_esm["default"].div(CreditCardFormFields_templateObject());
function validateCreditCardFormFields(param) {
    var cardNumber = param.cardNumber, expDate = param.expDate, cvc = param.cvc;
    var errors = {};
    if (!cardNumber) {
        errors.cardNumber = "H\xe9r vantar kortan\xfamer";
    } else if ((0,strings/* removeSpaces */.I8)(cardNumber).length < 13 || (0,strings/* removeSpaces */.I8)(cardNumber).length > 19) {
        errors.cardNumber = "Kortan\xfamer \xfearf a\xf0 vera \xe1 milli 13 og 19 t\xf6lustafir";
    }
    if (!expDate) {
        errors.expDate = "H\xe9r vantar gildist\xedma";
    } else if (expDate.length < 5) {
        errors.expDate = "Gildist\xedmi \xfearf a\xf0 vera \xe1 forminu MM/\xc1\xc1";
    }
    if (!cvc) {
        errors.cvc = "H\xe9r vantar CVC";
    } else if (cvc.length < 3) {
        errors.cvc = "CVC \xfearf a\xf0 vera 3 t\xf6lustafir";
    }
    return errors;
}
function CreditCardFormFields(param) {
    var isFormik = param.isFormik, errors = param.errors, values = param.values, onChange = param.onChange;
    var Input = isFormik ? components_form/* FormikCleaveInput */.mR : components_form/* CleaveInput */.n7;
    var props = isFormik ? {} : {
        cardNumber: {
            value: values === null || values === void 0 ? void 0 : values.cardNumber,
            onChange: onChange,
            showError: !!(errors === null || errors === void 0 ? void 0 : errors.cardNumber),
            errorMsg: errors === null || errors === void 0 ? void 0 : errors.cardNumber
        },
        expDate: {
            value: values === null || values === void 0 ? void 0 : values.expDate,
            onChange: onChange,
            showError: !!(errors === null || errors === void 0 ? void 0 : errors.expDate),
            errorMsg: errors === null || errors === void 0 ? void 0 : errors.expDate
        },
        cvc: {
            value: values === null || values === void 0 ? void 0 : values.cvc,
            onChange: onChange,
            showError: !!(errors === null || errors === void 0 ? void 0 : errors.cvc),
            errorMsg: errors === null || errors === void 0 ? void 0 : errors.cvc
        },
        store: {
            defaultChecked: values === null || values === void 0 ? void 0 : values.store,
            onClick: onChange
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, _objectSpread({
                    name: "cardNumber",
                    placeholder: "Kortan\xfamer",
                    options: {
                        creditCard: true,
                        creditCardStrictMode: true
                    }
                }, props.cardNumber, {
                    withGutter: !!(errors === null || errors === void 0 ? void 0 : errors.cardNumber)
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                md: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, _objectSpread({
                    name: "expDate",
                    placeholder: "Gildist\xedmi (MM/\xc1\xc1)",
                    options: {
                        date: true,
                        datePattern: [
                            "m",
                            "y"
                        ]
                    }
                }, props.expDate, {
                    withGutter: !!(errors === null || errors === void 0 ? void 0 : errors.expDate)
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                md: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, _objectSpread({
                    name: "cvc",
                    placeholder: "CVC",
                    maxLength: 3,
                    options: {
                        numericOnly: true,
                        numeralPositiveOnly: true
                    }
                }, props.cvc))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                md: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* Checkbox */.XZ, _objectSpread({
                        type: "checkbox",
                        name: "store",
                        withGutter: true,
                        label: "Vista kortauppl\xfdsingar"
                    }, props.store))
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/Payment.tsx
function Payment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Payment_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Payment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Payment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Payment_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Payment_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Payment_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Payment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function Payment_templateObject() {
    var data = Payment_taggedTemplateLiteral([
        "\n      padding-left: 56px;\n    "
    ]);
    Payment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Payment_templateObject1() {
    var data = Payment_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    Payment_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




















var PaymentType;
(function(PaymentType) {
    PaymentType[PaymentType["Valitor"] = 0] = "Valitor";
    PaymentType[PaymentType["Reikningur"] = 1] = "Reikningur";
})(PaymentType || (PaymentType = {}));
var Payment_obj;
var paymenIdMap = (Payment_obj = {}, Payment_defineProperty(Payment_obj, PaymentType.Valitor, "reon.payments.valitor_pay"), Payment_defineProperty(Payment_obj, PaymentType.Reikningur, "mirumee.payments.dummy"), Payment_obj);
var paymentTypeMap = {
    "reon.payments.valitor_pay": PaymentType.Valitor,
    "mirumee.payments.dummy": PaymentType.Reikningur
};
var Payment_IndentWrapper = styled_components_browser_esm["default"].div(Payment_templateObject1(), dist.media.md(Payment_templateObject()));
function Payment(param1) {
    var setPaymentInProgress = param1.setPaymentInProgress;
    var onError = function onError(msg) {
        react_toastify_esm/* toast.error */.Am.error(msg || "Grei\xf0sla mist\xf3kst");
        setIsLoading(false);
    };
    var ref14;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,UserContext/* useUser */.aF)(), valitorCards = ref1.valitorCards, removeValitorCard = ref1.removeValitorCard, currentCompany = ref1.currentCompany;
    var ref2 = (0,CheckoutContext/* useCheckout */.Mg)(), completeCheckout = ref2.completeCheckout, createPayment = ref2.createPayment, clearCart = ref2.clearCart, checkout = ref2.checkout;
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(false), showDeleteModal = ref4[0], setShowDeleteModal = ref4[1];
    var ref5 = (0,react.useState)(), cardIdToRemove = ref5[0], setCardIdToRemove = ref5[1];
    var ref6 = (0,react.useState)(false), cardIsVerified = ref6[0], setCardIsVerified = ref6[1];
    var ref7 = (0,react.useState)(), valitorActionUrl = ref7[0], setValitorActionUrl = ref7[1];
    var ref8 = (0,react.useState)(), valitorVerificationFields = ref8[0], setValitorVerificationFields = ref8[1];
    var ref9 = (0,react.useState)(), selectedPaymentId = ref9[0], setSelectedPaymentId = ref9[1];
    var ref10 = (0,react.useState)(), selectedCardId = ref10[0], setSelectedCardId = ref10[1];
    var ref11 = (0,react.useState)(false), newCardSelected = ref11[0], setNewCardSelected = ref11[1];
    var ref12 = (0,react.useState)({
        cardNumber: "",
        expDate: "",
        cvc: "",
        store: false
    }), cardFormValues = ref12[0], setCardFormValues = ref12[1];
    var ref13 = (0,react.useState)({
        cardNumber: "",
        expDate: "",
        cvc: ""
    }), cardErrors = ref13[0], setCardErrors = ref13[1];
    var selectedCard = valitorCards ? selectedCardId && valitorCards.find(function(param) {
        var id = param.id;
        return id === selectedCardId;
    }) : undefined;
    var paymentGateways = checkout === null || checkout === void 0 ? void 0 : (ref14 = checkout.availablePaymentGateways) === null || ref14 === void 0 ? void 0 : ref14.filter(function(pg) {
        return pg.id === paymenIdMap[PaymentType.Valitor] || currentCompany && currentCompany.invoicingAllowed && pg.id === paymenIdMap[PaymentType.Reikningur];
    });
    (0,react.useEffect)(function() {
        if ((paymentGateways === null || paymentGateways === void 0 ? void 0 : paymentGateways.length) === 1) {
            setSelectedPaymentId(paymentGateways[0].id);
        }
    }, [
        paymentGateways
    ]);
    var handleSelectVirtualCard = (0,react.useCallback)(function(id) {
        setSelectedCardId(id);
        setNewCardSelected(false);
    }, [
        setSelectedCardId,
        setNewCardSelected
    ]);
    var handleSelectNewCard = (0,react.useCallback)(function() {
        setSelectedCardId("");
        setNewCardSelected(true);
    }, [
        setSelectedCardId,
        setNewCardSelected
    ]);
    var handleDeleteConfirmation = (0,react.useCallback)(function(card) {
        setCardIdToRemove(card.id);
        setShowDeleteModal(true);
    }, [
        setCardIdToRemove,
        setShowDeleteModal
    ]);
    var handleDeleteCreditCard = (0,react.useCallback)(function() {
        setSelectedCardId(undefined);
        if (cardIdToRemove) {
            removeValitorCard(cardIdToRemove);
        }
        setShowDeleteModal(false);
    }, [
        removeValitorCard,
        setSelectedCardId,
        setShowDeleteModal,
        cardIdToRemove
    ]);
    var createValitorCardToken = (0,react.useCallback)(function(data) {
        return rest/* restApi.paymentsValitorPayTokensCreate */._O.paymentsValitorPayTokensCreate(data).then(function(res) {
            var ref;
            return res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.token;
        }).catch(function() {
            return undefined;
        });
    }, []);
    var onChangeCard = (0,react.useCallback)(function(e) {
        var target = e.target;
        var value = target.type === "checkbox" ? target.checked : target.value;
        var name = target.name;
        setCardFormValues(Payment_objectSpread({}, cardFormValues, Payment_defineProperty({}, name, value)));
    }, [
        cardFormValues
    ]);
    var onSubmit = (0,react.useCallback)(Payment_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, ref15, ref16, paymentToken, ref17, formErrors, cardNumber, expDate, cvc, store, date, year, cardId, payment, error, checkoutCompleteData, checkoutError, ref18, productName, orderToken, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    setPaymentInProgress(true);
                    setIsLoading(true);
                    ;
                    if (!(selectedPaymentId === paymenIdMap[PaymentType.Valitor])) {
                        _ctx.next = 33;
                        break;
                    }
                    if (!(newCardSelected || !(valitorCards === null || valitorCards === void 0 ? void 0 : valitorCards.length))) {
                        _ctx.next = 23;
                        break;
                    }
                    ;
                    formErrors = validateCreditCardFormFields({
                        cardNumber: cardFormValues === null || cardFormValues === void 0 ? void 0 : cardFormValues.cardNumber,
                        expDate: cardFormValues === null || cardFormValues === void 0 ? void 0 : cardFormValues.expDate,
                        cvc: cardFormValues === null || cardFormValues === void 0 ? void 0 : cardFormValues.cvc
                    });
                    if (!((ref17 = Object.keys(formErrors)) === null || ref17 === void 0 ? void 0 : ref17.length)) {
                        _ctx.next = 12;
                        break;
                    }
                    setCardErrors(formErrors);
                    setIsLoading(false);
                    return _ctx.abrupt("return");
                case 12:
                    cardNumber = cardFormValues.cardNumber, expDate = cardFormValues.expDate, cvc = cardFormValues.cvc, store = cardFormValues.store;
                    date = expDate.split("/");
                    year = "20".concat(date[1]);
                    _ctx.next = 17;
                    return createValitorCardToken({
                        cardNumber: (0,strings/* removeSpaces */.I8)(cardNumber),
                        expMonth: parseInt(date[0], 10),
                        expYear: parseInt(year, 10),
                        cvc: cvc,
                        store: store
                    });
                case 17:
                    paymentToken = _ctx.sent;
                    if (paymentToken) {
                        _ctx.next = 21;
                        break;
                    }
                    onError("Athuga\xf0u hvort kortauppl\xfdsingar s\xe9u r\xe9ttar");
                    return _ctx.abrupt("return");
                case 21:
                    _ctx.next = 31;
                    break;
                case 23:
                    if (!(!selectedCard || typeof selectedCard === "string")) {
                        _ctx.next = 25;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 25:
                    cardId = selectedCard.id;
                    if (cardId) {
                        _ctx.next = 28;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 28:
                    _ctx.next = 30;
                    return createValitorCardToken({
                        virtualCardId: cardId
                    });
                case 30:
                    paymentToken = _ctx.sent;
                case 31:
                    _ctx.next = 34;
                    break;
                case 33:
                    if (selectedPaymentId === paymenIdMap[PaymentType.Reikningur]) {
                        paymentToken = "InvoiceToken";
                    }
                case 34:
                    if (!selectedPaymentId) {
                        _ctx.next = 40;
                        break;
                    }
                    _ctx.next = 37;
                    return createPayment({
                        gateway: selectedPaymentId,
                        token: paymentToken
                    });
                case 37:
                    _ctx.t0 = _ctx.sent;
                    _ctx.next = 41;
                    break;
                case 40:
                    _ctx.t0 = null;
                case 41:
                    payment = _ctx.t0;
                    error = payment === null || payment === void 0 ? void 0 : (ref = payment.errors) === null || ref === void 0 ? void 0 : ref[0];
                    if (!error) {
                        _ctx.next = 46;
                        break;
                    }
                    onError(constants/* checkoutErrorCodeMap */.Jg[error === null || error === void 0 ? void 0 : error.code]);
                    return _ctx.abrupt("return");
                case 46:
                    _ctx.next = 48;
                    return completeCheckout();
                case 48:
                    checkoutCompleteData = _ctx.sent;
                    checkoutError = checkoutCompleteData === null || checkoutCompleteData === void 0 ? void 0 : (ref15 = checkoutCompleteData.errors) === null || ref15 === void 0 ? void 0 : ref15[0];
                    if (!(checkoutError && !(checkoutCompleteData === null || checkoutCompleteData === void 0 ? void 0 : checkoutCompleteData.confirmationNeeded))) {
                        _ctx.next = 53;
                        break;
                    }
                    if ((checkoutError === null || checkoutError === void 0 ? void 0 : checkoutError.code) === "INSUFFICIENT_STOCK") {
                        ;
                        productName = checkoutError === null || checkoutError === void 0 ? void 0 : (ref18 = checkoutError.message) === null || ref18 === void 0 ? void 0 : ref18.split(":")[1];
                        onError("Ekki n\xe6gilegt magn til \xe1 lager af".concat(productName));
                    } else {
                        onError(constants/* checkoutErrorCodeMap */.Jg[checkoutError.code]);
                    }
                    return _ctx.abrupt("return");
                case 53:
                    orderToken = checkoutCompleteData === null || checkoutCompleteData === void 0 ? void 0 : (ref16 = checkoutCompleteData.order) === null || ref16 === void 0 ? void 0 : ref16.token;
                    if ((checkoutCompleteData === null || checkoutCompleteData === void 0 ? void 0 : checkoutCompleteData.confirmationNeeded) && selectedPaymentId === paymenIdMap[PaymentType.Valitor]) {
                        data = JSON.parse(checkoutCompleteData === null || checkoutCompleteData === void 0 ? void 0 : checkoutCompleteData.confirmationData);
                        setCardIsVerified(data === null || data === void 0 ? void 0 : data.isSuccess);
                        setValitorActionUrl(data === null || data === void 0 ? void 0 : data.postUrl);
                        setValitorVerificationFields(data === null || data === void 0 ? void 0 : data.verificationFields);
                    }
                    if (orderToken) {
                        router.push("".concat(paths/* paths.order */.H.order).concat(orderToken, "/")).then(function() {
                            clearCart();
                        });
                    } else {
                        setIsLoading(false);
                        setPaymentInProgress(false);
                    }
                case 56:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        setPaymentInProgress,
        selectedPaymentId,
        createPayment,
        completeCheckout,
        newCardSelected,
        valitorCards === null || valitorCards === void 0 ? void 0 : valitorCards.length,
        cardFormValues,
        createValitorCardToken,
        selectedCard,
        router,
        clearCart, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            paymentGateways === null || paymentGateways === void 0 ? void 0 : paymentGateways.map(function(pg) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CheckoutRadioCard, {
                    title: pg.id === paymenIdMap[PaymentType.Valitor] ? "Borga me\xf0 grei\xf0slukorti" : "Setja \xed reikning",
                    icon: pg.id === paymenIdMap[PaymentType.Valitor] ? /*#__PURE__*/ (0,jsx_runtime.jsx)((BankCardLineIcon_default()), {
                        size: 30,
                        color: themes/* theme.palette.primary */.r.palette.primary
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((BillLineIcon_default()), {
                        size: 30,
                        color: themes/* theme.palette.primary */.r.palette.primary
                    }),
                    selected: selectedPaymentId === pg.id,
                    onSelect: function() {
                        return setSelectedPaymentId(pg.id);
                    },
                    children: pg.id === paymenIdMap[PaymentType.Valitor] && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                        spacing: 12,
                        children: (valitorCards === null || valitorCards === void 0 ? void 0 : valitorCards.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                valitorCards === null || valitorCards === void 0 ? void 0 : valitorCards.map(function(card) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardRadioCard, {
                                        selected: card === selectedCard,
                                        onSelect: function() {
                                            return handleSelectVirtualCard(card.id);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardInfo, {
                                            cardInfo: card,
                                            selected: card === selectedCard,
                                            onSelect: function() {
                                                return handleSelectVirtualCard(card.id);
                                            },
                                            onDelete: function() {
                                                return handleDeleteConfirmation(card);
                                            }
                                        })
                                    }, card.id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardRadioCard, {
                                    selected: newCardSelected,
                                    onSelect: handleSelectNewCard,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardForm, {
                                        selected: newCardSelected,
                                        onSelect: handleSelectNewCard,
                                        errors: cardErrors,
                                        values: cardFormValues,
                                        onChange: onChangeCard
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardFormFields, {
                            errors: cardErrors,
                            values: cardFormValues,
                            onChange: onChangeCard
                        })
                    })
                }, pg.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                spacing: 36,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Payment_IndentWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                        withGutter: true,
                        color: "secondary",
                        outlined: true,
                        loading: isLoading,
                        disabled: !selectedPaymentId || !(checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress) || selectedPaymentId === paymenIdMap[PaymentType.Valitor] && !!(valitorCards === null || valitorCards === void 0 ? void 0 : valitorCards.length) && !selectedCard && !newCardSelected,
                        onClick: onSubmit,
                        children: "Kl\xe1ra kaup"
                    })
                })
            }),
            valitorActionUrl && cardIsVerified && valitorVerificationFields ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Valitor3DSecureProcessingForm, {
                actionUrl: valitorActionUrl,
                isSuccess: cardIsVerified,
                fields: valitorVerificationFields
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Modal */.u_, {
                setShow: setShowDeleteModal,
                show: showDeleteModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DeleteConfirmation */.L3, {
                    title: "Ertu viss um a\xf0 \xfe\xfa viljir ey\xf0a kortauppl\xfdsingunum \xfe\xednum?",
                    text: "\xde\xfa munt ekki geta teki\xf0 \xfeessa a\xf0ger\xf0 til baka!",
                    onCancel: function() {
                        return setShowDeleteModal(false);
                    },
                    onRemove: handleDeleteCreditCard,
                    cancelText: "H\xe6tta vi\xf0",
                    submitText: "Ey\xf0a korti"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/CreditCardForm.tsx
function CreditCardForm_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CreditCardForm_templateObject() {
    var data = CreditCardForm_taggedTemplateLiteral([
        "\n    padding: 34px;\n  "
    ]);
    CreditCardForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CreditCardForm_templateObject1() {
    var data = CreditCardForm_taggedTemplateLiteral([
        "\n  position: relative;\n\n  margin: 16px 0;\n  width: 100%;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  padding: 34px 34px 34px 24px;\n\n  ",
        "\n\n  &.selected {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    CreditCardForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CreditCardForm_templateObject2() {
    var data = CreditCardForm_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-bottom: 24px;\n"
    ]);
    CreditCardForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CreditCardForm_templateObject3() {
    var data = CreditCardForm_taggedTemplateLiteral([
        "\n    padding-right: 50px;\n  "
    ]);
    CreditCardForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CreditCardForm_templateObject4() {
    var data = CreditCardForm_taggedTemplateLiteral([
        "\n  padding-right: 24px;\n\n  ",
        "\n"
    ]);
    CreditCardForm_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var FormWrapper = styled_components_browser_esm["default"].div(CreditCardForm_templateObject1(), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"), dist.media.md(CreditCardForm_templateObject()), (0,es/* palette */.DG)("red"));
var TitleWrapper = styled_components_browser_esm["default"].div(CreditCardForm_templateObject2());
var CreditCardForm_IconContainer = styled_components_browser_esm["default"].div(CreditCardForm_templateObject4(), dist.media.md(CreditCardForm_templateObject3()));
function CreditCardForm(param) {
    var selected = param.selected, onSelect = param.onSelect, errors = param.errors, values = param.values, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormWrapper, {
        onClick: onSelect,
        className: classnames_default()({
            selected: selected
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardForm_IconContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((BankCardLineIcon_default()), {
                            size: 30,
                            color: themes/* theme.palette.primary */.r.palette.primary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                        children: "N\xfdtt grei\xf0slukort"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Expandable */.Ak, {
                expanded: selected,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardFormFields, {
                    errors: errors,
                    values: values,
                    onChange: onChange
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/account/index.tsx + 9 modules
var account = __webpack_require__(84047);
;// CONCATENATED MODULE: ./src/components/checkout/CreditCardInfo.tsx






function CreditCardInfo(param) {
    var cardInfo = param.cardInfo, selected = param.selected, onSelect = param.onSelect, onDelete = param.onDelete;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(account/* InfoCard */.rJ, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((BankCardLineIcon_default()), {
            size: 30,
            color: themes/* theme.palette.primary */.r.palette.primary
        }),
        selected: selected,
        onSelect: onSelect,
        deleteIcon: true,
        title: "",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                    children: [
                        cardInfo === null || cardInfo === void 0 ? void 0 : cardInfo.brand,
                        " - ",
                        cardInfo === null || cardInfo === void 0 ? void 0 : (ref = cardInfo.maskedCardNumber) === null || ref === void 0 ? void 0 : ref.slice(-4)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                    children: [
                        "Gildist\xedmi ",
                        cardInfo === null || cardInfo === void 0 ? void 0 : cardInfo.expMonth,
                        "/",
                        cardInfo === null || cardInfo === void 0 ? void 0 : cardInfo.expYear
                    ]
                })
            ]
        }),
        cornerButton: true,
        handleDelete: onDelete,
        pointerCursor: true
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/CreditCardRadioCard.tsx
function CreditCardRadioCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CreditCardRadioCard_templateObject() {
    var data = CreditCardRadioCard_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    CreditCardRadioCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CreditCardRadioCard_templateObject1() {
    var data = CreditCardRadioCard_taggedTemplateLiteral([
        "\n    width: 56px;\n    min-width: 56px;\n    display: inherit;\n  "
    ]);
    CreditCardRadioCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CreditCardRadioCard_templateObject2() {
    var data = CreditCardRadioCard_taggedTemplateLiteral([
        "\n  width: 40px;\n  min-width: 40px;\n  display: flex;\n  align-items: center;\n  display: none;\n\n  ",
        "\n"
    ]);
    CreditCardRadioCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var CreditCardRadioCard_Wrapper = styled_components_browser_esm["default"].div(CreditCardRadioCard_templateObject());
var CreditCardRadioCard_RadioContainer = styled_components_browser_esm["default"].div(CreditCardRadioCard_templateObject2(), dist.media.md(CreditCardRadioCard_templateObject1()));
function CreditCardRadioCard(param) {
    var selected = param.selected, onSelect = param.onSelect, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CreditCardRadioCard_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardRadioCard_RadioContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* RadioButton */.EU, {
                    checked: selected,
                    onChange: onSelect
                })
            }),
            children
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 32 modules
var format = __webpack_require__(95747);
;// CONCATENATED MODULE: ./src/utils/dates.ts

// TODO: Test
function formatDate(date) {
    return (0,format/* default */.Z)(Date.parse(date), "dd/MM/yyyy");
}

// EXTERNAL MODULE: ./src/utils/graphql.ts
var graphql = __webpack_require__(27429);
;// CONCATENATED MODULE: ./src/components/checkout/CheckoutReceipt.tsx
function CheckoutReceipt_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CheckoutReceipt_templateObject() {
    var data = CheckoutReceipt_taggedTemplateLiteral([
        "\n    padding: 0 32px;\n  "
    ]);
    CheckoutReceipt_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckoutReceipt_templateObject1() {
    var data = CheckoutReceipt_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  padding: 0 8px;\n\n  ",
        "\n"
    ]);
    CheckoutReceipt_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckoutReceipt_templateObject2() {
    var data = CheckoutReceipt_taggedTemplateLiteral([
        "\n  padding: 16px 0;\n"
    ]);
    CheckoutReceipt_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckoutReceipt_templateObject3() {
    var data = CheckoutReceipt_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 5px 0;\n  position: relative;\n"
    ]);
    CheckoutReceipt_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var Receipt = styled_components_browser_esm["default"].div(CheckoutReceipt_templateObject1(), dist.media.md(CheckoutReceipt_templateObject()));
var SummaryLines = styled_components_browser_esm["default"].div(CheckoutReceipt_templateObject2());
var ReceiptLine = styled_components_browser_esm["default"].div(CheckoutReceipt_templateObject3());
function CheckoutReceipt(param) {
    var order = param.order;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var lines = order.lines, created = order.created, total = order.total, subtotal = order.subtotal, discounts = order.discounts, id = order.id, shippingPrice = order.shippingPrice;
    var date = formatDate(created);
    var subTotal = subtotal === null || subtotal === void 0 ? void 0 : (ref = subtotal.gross) === null || ref === void 0 ? void 0 : ref.amount;
    var vsk = subtotal === null || subtotal === void 0 ? void 0 : (ref1 = subtotal.tax) === null || ref1 === void 0 ? void 0 : ref1.amount;
    var shippingPriceAmount = shippingPrice === null || shippingPrice === void 0 ? void 0 : (ref2 = shippingPrice.gross) === null || ref2 === void 0 ? void 0 : ref2.amount;
    var totalPrice = total === null || total === void 0 ? void 0 : (ref3 = total.gross) === null || ref3 === void 0 ? void 0 : ref3.amount;
    // TODO: Test with discount, when discount is solved in BC
    var discount = discounts === null || discounts === void 0 ? void 0 : (ref4 = discounts[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.amount) === null || ref5 === void 0 ? void 0 : ref5.amount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Receipt, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title4 */.Gn, {
                children: "P\xf6ntun #".concat((ref6 = (0,graphql/* fromGlobalId */.Qz)(id)) === null || ref6 === void 0 ? void 0 : ref6.id)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                withGutter: true,
                color: "black40",
                children: date
            }),
            lines === null || lines === void 0 ? void 0 : lines.filter(isNotNull/* isNotNull */.K).map(function(line) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutReceiptLine, {
                    line: line
                }, line.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryLines, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptLine, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                                children: "Ver\xf0 me\xf0 VSK "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                                children: [
                                    (0,numbers/* formatNumber */.uf)(subTotal),
                                    " kr."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptLine, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                                children: "\xdear af VSK "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                                children: [
                                    (0,numbers/* formatNumber */.uf)(vsk),
                                    " kr."
                                ]
                            })
                        ]
                    }),
                    discount && discount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptLine, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                                children: "Afsl\xe1ttur"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                                color: "red",
                                children: [
                                    (0,numbers/* formatNumber */.uf)(-1 * discount),
                                    " kr."
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptLine, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                                children: "Sendingarkostna\xf0ur"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                                children: [
                                    (0,numbers/* formatNumber */.uf)(shippingPriceAmount),
                                    " kr."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptLine, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                                bold: true,
                                children: "Samtals"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* PLarge */.cG, {
                                bold: true,
                                children: [
                                    (0,numbers/* formatNumber */.uf)(totalPrice),
                                    " kr."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/CheckoutReceiptLine.tsx
function CheckoutReceiptLine_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CheckoutReceiptLine_templateObject() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  padding: 16px 0;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    CheckoutReceiptLine_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject1() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    CheckoutReceiptLine_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject2() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  grid-template-rows:1fr;\n  grid-template-columns: 3fr 1fr 1fr;\n  "
    ]);
    CheckoutReceiptLine_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject3() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 2fr 1fr;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    CheckoutReceiptLine_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject4() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n    display: block;\n    "
    ]);
    CheckoutReceiptLine_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject5() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  justify-self: end;\n\n  &:nth-child(n) {\n    display: none;\n    align-self: end;\n\n    ",
        "\n  }\n\n  &:first-child {\n    display: block;\n    justify-self: start;\n  }\n"
    ]);
    CheckoutReceiptLine_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject6() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 0.875rem;\n  margin-bottom: 5px;\n"
    ]);
    CheckoutReceiptLine_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject7() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  display: none;\n  "
    ]);
    CheckoutReceiptLine_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject8() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  padding-top: 14px;\n  padding-right: 12px;\n\n  ",
        "\n"
    ]);
    CheckoutReceiptLine_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CheckoutReceiptLine_templateObject9() {
    var data = CheckoutReceiptLine_taggedTemplateLiteral([
        "\n  justify-self: end;\n\n  &:first-child {\n    justify-self: start;\n  }\n"
    ]);
    CheckoutReceiptLine_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}







var CheckoutReceiptLine_Wrapper = styled_components_browser_esm["default"].div(CheckoutReceiptLine_templateObject(), (0,es/* palette */.DG)("black20"));
var InfoWrapper = styled_components_browser_esm["default"].div(CheckoutReceiptLine_templateObject1());
var InfoLine = styled_components_browser_esm["default"].div(CheckoutReceiptLine_templateObject3(), dist.media.md(CheckoutReceiptLine_templateObject2()));
var InfoLineItem = styled_components_browser_esm["default"].div(CheckoutReceiptLine_templateObject5(), dist.media.md(CheckoutReceiptLine_templateObject4()));
var SkuWrapper = styled_components_browser_esm["default"].div(CheckoutReceiptLine_templateObject6(), (0,es/* palette */.DG)("black40"));
var MobileLine = styled_components_browser_esm["default"].div(CheckoutReceiptLine_templateObject8(), dist.media.md(CheckoutReceiptLine_templateObject7()));
var MobileLineItem = styled_components_browser_esm["default"].div(CheckoutReceiptLine_templateObject9());
function CheckoutReceiptLine(param) {
    var line = param.line;
    var variant = line.variant, quantity = line.quantity, totalPrice = line.totalPrice;
    var product = variant === null || variant === void 0 ? void 0 : variant.product;
    var sku = variant === null || variant === void 0 ? void 0 : variant.sku;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutReceiptLine_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoLine, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoLineItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuWrapper, {
                                children: sku
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title6 */.L8, {
                                children: product === null || product === void 0 ? void 0 : product.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoLineItem, {
                        children: [
                            quantity,
                            " stk."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoLineItem, {
                        children: [
                            (0,numbers/* formatNumber */.uf)(totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.gross.amount),
                            " kr."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileLine, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileLineItem, {
                                children: [
                                    quantity,
                                    " stk."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileLineItem, {
                                children: [
                                    " ",
                                    (0,numbers/* formatNumber */.uf)(totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.gross.amount),
                                    " kr."
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/styles/shadowStyles.ts
var shadowStyles = __webpack_require__(23633);
;// CONCATENATED MODULE: ./src/components/checkout/CheckoutReceiptWrapper.tsx
function CheckoutReceiptWrapper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CheckoutReceiptWrapper_templateObject() {
    var data = CheckoutReceiptWrapper_taggedTemplateLiteral([
        "\n    padding: 48px;\n    margin-bottom: 56px;\n  "
    ]);
    CheckoutReceiptWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckoutReceiptWrapper_templateObject1() {
    var data = CheckoutReceiptWrapper_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  padding: 16px;\n  flex-direction: column;\n  align-items: stretch;\n  background-color: ",
        ";\n  z-index: -2;\n  border: 1px solid ",
        ";\n  margin-bottom: 32px;\n\n  ",
        "\n"
    ]);
    CheckoutReceiptWrapper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckoutReceiptWrapper_templateObject2() {
    var data = CheckoutReceiptWrapper_taggedTemplateLiteral([
        "\n    padding: 24px;\n  "
    ]);
    CheckoutReceiptWrapper_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckoutReceiptWrapper_templateObject3() {
    var data = CheckoutReceiptWrapper_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 18px;\n  display: flex;\n  align-items: center;\n  border: 1px solid ",
        ";\n  margin-bottom: 50px;\n  background-color: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    CheckoutReceiptWrapper_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CheckoutReceiptWrapper_templateObject4() {
    var data = CheckoutReceiptWrapper_taggedTemplateLiteral([
        "\n    width: 53px;\n  "
    ]);
    CheckoutReceiptWrapper_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CheckoutReceiptWrapper_templateObject5() {
    var data = CheckoutReceiptWrapper_taggedTemplateLiteral([
        "\n  width: 42px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n\n  ",
        "\n"
    ]);
    CheckoutReceiptWrapper_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








var CheckoutReceiptWrapper_Card = styled_components_browser_esm["default"].div(CheckoutReceiptWrapper_templateObject1(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black10"), dist.media.md(CheckoutReceiptWrapper_templateObject()));
var CheckoutReceiptWrapper_CardHead = styled_components_browser_esm["default"].div(CheckoutReceiptWrapper_templateObject3(), (0,es/* palette */.DG)("primary"), (0,es/* palette */.DG)("white"), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: false
}), dist.media.md(CheckoutReceiptWrapper_templateObject2()));
var Logo = styled_components_browser_esm["default"].img(CheckoutReceiptWrapper_templateObject5(), dist.media.sm(CheckoutReceiptWrapper_templateObject4()));
function CheckoutReceiptWrapper(param) {
    var order = param.order, method = param.method;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutReceiptWrapper_Card, {
        children: [
            !method && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutReceiptWrapper_CardHead, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                        src: "/assets/rv-logo-solid.png",
                        alt: "logo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title5 */.IV, {
                        children: "Takk fyrir a\xf0 panta hj\xe1 Rekstrarv\xf6rum!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutReceipt, {
                order: order
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/CheckoutEmailUpdate.tsx





function CheckoutEmailUpdate(param) {
    var setNewCheckoutEmail = param.setNewCheckoutEmail, errors = param.errors;
    var user = useUser().user;
    var initialValues = user === null || user === void 0 ? void 0 : user.email;
    var handleChange = useCallback(function(e) {
        setNewCheckoutEmail(e.target.value);
    }, [
        setNewCheckoutEmail
    ]);
    return /*#__PURE__*/ _jsx(SpacingWrapper, {
        spacing: 20,
        children: /*#__PURE__*/ _jsx(Input, {
            label: "Netfang til \xfeess a\xf0 senda uppl\xfdsingar um p\xf6ntun",
            name: "email",
            type: "email",
            onChange: handleChange,
            defaultValue: initialValues,
            withGutter: true,
            showError: !!(errors === null || errors === void 0 ? void 0 : errors.email),
            errorMsg: errors === null || errors === void 0 ? void 0 : errors.email
        })
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/Valitor3DSecureProcessingForm.tsx


function Valitor3DSecureProcessingForm(param1) {
    var actionUrl = param1.actionUrl, fields = param1.fields, isSuccess = param1.isSuccess;
    var formRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (fields && isSuccess) {
            if (formRef.current && formRef.current.submit) {
                formRef.current.submit();
            }
        }
    }, [
        fields,
        isSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        ref: formRef,
        id: "webform0",
        name: "red2ACSv1",
        method: "POST",
        action: actionUrl,
        acceptCharset: "UTF-8",
        children: fields === null || fields === void 0 ? void 0 : fields.map(function(param) {
            var name = param.name, value = param.value;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "hidden",
                name: name,
                value: value
            }, name);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/FileListLineIcon.js
var FileListLineIcon = __webpack_require__(85771);
var FileListLineIcon_default = /*#__PURE__*/__webpack_require__.n(FileListLineIcon);
// EXTERNAL MODULE: ./src/api/saleor/generated/index.tsx
var generated = __webpack_require__(49554);
;// CONCATENATED MODULE: ./src/components/checkout/CheckoutCompleteInfoCard.tsx
function CheckoutCompleteInfoCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CheckoutCompleteInfoCard_templateObject() {
    var data = CheckoutCompleteInfoCard_taggedTemplateLiteral([
        "\n    padding: 48px;\n  "
    ]);
    CheckoutCompleteInfoCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckoutCompleteInfoCard_templateObject1() {
    var data = CheckoutCompleteInfoCard_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: 16px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n\n  ",
        "\n"
    ]);
    CheckoutCompleteInfoCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckoutCompleteInfoCard_templateObject2() {
    var data = CheckoutCompleteInfoCard_taggedTemplateLiteral([
        "\n    width: 50%;\n    padding: 48px;\n    margin-bottom: 56px;\n  "
    ]);
    CheckoutCompleteInfoCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckoutCompleteInfoCard_templateObject3() {
    var data = CheckoutCompleteInfoCard_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 24px;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n  margin-bottom: 16px;\n\n  ",
        "\n"
    ]);
    CheckoutCompleteInfoCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CheckoutCompleteInfoCard_templateObject4() {
    var data = CheckoutCompleteInfoCard_taggedTemplateLiteral([
        "\n  margin-right: 24px;\n"
    ]);
    CheckoutCompleteInfoCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CheckoutCompleteInfoCard_templateObject5() {
    var data = CheckoutCompleteInfoCard_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    CheckoutCompleteInfoCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CheckoutCompleteInfoCard_templateObject6() {
    var data = CheckoutCompleteInfoCard_taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  line-height: 1.8;\n"
    ]);
    CheckoutCompleteInfoCard_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}















var paymentMap = {
    "reon.payments.valitor_pay": "Grei\xf0sla me\xf0 korti",
    "mirumee.payments.dummy": "\xcd reikning"
};
var CheckoutCompleteInfoCard_Card = styled_components_browser_esm["default"].div(CheckoutCompleteInfoCard_templateObject1(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black10"), dist.media.md(CheckoutCompleteInfoCard_templateObject()));
var InfoSectionWrapper = styled_components_browser_esm["default"].div(CheckoutCompleteInfoCard_templateObject3(), (0,es/* palette */.DG)("black20"), dist.media.md(CheckoutCompleteInfoCard_templateObject2()));
var IconBox = styled_components_browser_esm["default"].div(CheckoutCompleteInfoCard_templateObject4());
var InfoLineWrapper = styled_components_browser_esm["default"].div(CheckoutCompleteInfoCard_templateObject5());
var CheckoutCompleteInfoCard_InfoLine = styled_components_browser_esm["default"].div(CheckoutCompleteInfoCard_templateObject6());
function CheckoutCompleteInfoCard(param) {
    var children = param.children, order = param.order;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var shippingMethod = order === null || order === void 0 ? void 0 : order.shippingMethod;
    var payments = order === null || order === void 0 ? void 0 : order.payments;
    var payment = payments === null || payments === void 0 ? void 0 : payments.filter(isNotNull/* isNotNull */.K).find(function(p) {
        return p.chargeStatus === generated/* PaymentChargeStatusEnum.FullyCharged */.Rev.FullyCharged;
    });
    var creditCard = (payment === null || payment === void 0 ? void 0 : payment.gateway) === "reon.payments.valitor_pay" && (payment === null || payment === void 0 ? void 0 : payment.creditCard);
    var shippingAddressName = (order === null || order === void 0 ? void 0 : (ref = order.shippingAddress) === null || ref === void 0 ? void 0 : ref.firstName) || (order === null || order === void 0 ? void 0 : (ref1 = order.shippingAddress) === null || ref1 === void 0 ? void 0 : ref1.companyName);
    var billingAddressName = (order === null || order === void 0 ? void 0 : (ref2 = order.billingAddress) === null || ref2 === void 0 ? void 0 : ref2.firstName) || (order === null || order === void 0 ? void 0 : (ref3 = order.billingAddress) === null || ref3 === void 0 ? void 0 : ref3.companyName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutCompleteInfoCard_Card, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSectionWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((UserLineIcon_default()), {
                            size: 32,
                            color: themes/* theme.palette.primary */.r.palette.primary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoLineWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                withGutter: true,
                                children: "M\xf3ttakandi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: shippingAddressName
                            }),
                            (order === null || order === void 0 ? void 0 : (ref4 = order.shippingAddress) === null || ref4 === void 0 ? void 0 : ref4.lastName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: (0,kennitala_min.format)(order === null || order === void 0 ? void 0 : (ref5 = order.shippingAddress) === null || ref5 === void 0 ? void 0 : ref5.lastName)
                            }) : null,
                            (order === null || order === void 0 ? void 0 : (ref6 = order.shippingAddress) === null || ref6 === void 0 ? void 0 : ref6.phone) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: (0,strings/* formatPhoneNumber */.un)(order === null || order === void 0 ? void 0 : (ref7 = order.shippingAddress) === null || ref7 === void 0 ? void 0 : ref7.phone)
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutCompleteInfoCard_InfoLine, {
                                children: [
                                    order === null || order === void 0 ? void 0 : (ref8 = order.shippingAddress) === null || ref8 === void 0 ? void 0 : ref8.streetAddress1,
                                    ","
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutCompleteInfoCard_InfoLine, {
                                children: [
                                    order === null || order === void 0 ? void 0 : (ref9 = order.shippingAddress) === null || ref9 === void 0 ? void 0 : ref9.postalCode,
                                    " ",
                                    order === null || order === void 0 ? void 0 : (ref10 = order.shippingAddress) === null || ref10 === void 0 ? void 0 : ref10.city
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSectionWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((FileListLineIcon_default()), {
                            size: 32,
                            color: themes/* theme.palette.primary */.r.palette.primary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoLineWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                withGutter: true,
                                children: "Grei\xf0andi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: billingAddressName
                            }),
                            (order === null || order === void 0 ? void 0 : (ref11 = order.billingAddress) === null || ref11 === void 0 ? void 0 : ref11.lastName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: (0,kennitala_min.format)(order === null || order === void 0 ? void 0 : (ref12 = order.billingAddress) === null || ref12 === void 0 ? void 0 : ref12.lastName)
                            }) : null,
                            (order === null || order === void 0 ? void 0 : (ref13 = order.billingAddress) === null || ref13 === void 0 ? void 0 : ref13.phone) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: (0,strings/* formatPhoneNumber */.un)(order === null || order === void 0 ? void 0 : (ref14 = order.billingAddress) === null || ref14 === void 0 ? void 0 : ref14.phone)
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutCompleteInfoCard_InfoLine, {
                                children: [
                                    order === null || order === void 0 ? void 0 : (ref15 = order.billingAddress) === null || ref15 === void 0 ? void 0 : ref15.streetAddress1,
                                    ","
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutCompleteInfoCard_InfoLine, {
                                children: [
                                    order === null || order === void 0 ? void 0 : (ref16 = order.billingAddress) === null || ref16 === void 0 ? void 0 : ref16.postalCode,
                                    " ",
                                    order === null || order === void 0 ? void 0 : (ref17 = order.billingAddress) === null || ref17 === void 0 ? void 0 : ref17.city
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSectionWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((TruckLineIcon_default()), {
                            size: 32,
                            color: themes/* theme.palette.primary */.r.palette.primary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoLineWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                withGutter: true,
                                children: "Afhending"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.name
                            }),
                            (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.name) === "Dropp Heimsending" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                        children: shippingAddressName
                                    }),
                                    (order === null || order === void 0 ? void 0 : (ref18 = order.shippingAddress) === null || ref18 === void 0 ? void 0 : ref18.lastName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                        children: (0,kennitala_min.format)(order === null || order === void 0 ? void 0 : (ref19 = order.shippingAddress) === null || ref19 === void 0 ? void 0 : ref19.lastName)
                                    }) : null,
                                    (order === null || order === void 0 ? void 0 : (ref20 = order.shippingAddress) === null || ref20 === void 0 ? void 0 : ref20.phone) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                        children: (0,strings/* formatPhoneNumber */.un)(order === null || order === void 0 ? void 0 : (ref21 = order.shippingAddress) === null || ref21 === void 0 ? void 0 : ref21.phone)
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutCompleteInfoCard_InfoLine, {
                                        children: [
                                            order === null || order === void 0 ? void 0 : (ref22 = order.shippingAddress) === null || ref22 === void 0 ? void 0 : ref22.streetAddress1,
                                            ","
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutCompleteInfoCard_InfoLine, {
                                        children: [
                                            order === null || order === void 0 ? void 0 : (ref23 = order.shippingAddress) === null || ref23 === void 0 ? void 0 : ref23.postalCode,
                                            " ",
                                            order === null || order === void 0 ? void 0 : (ref24 = order.shippingAddress) === null || ref24 === void 0 ? void 0 : ref24.city
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSectionWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((BankCardLineIcon_default()), {
                            size: 32,
                            color: themes/* theme.palette.primary */.r.palette.primary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoLineWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                withGutter: true,
                                children: "Grei\xf0sla"
                            }),
                            (payment === null || payment === void 0 ? void 0 : payment.gateway) && paymentMap[payment.gateway] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: paymentMap[payment === null || payment === void 0 ? void 0 : payment.gateway]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutCompleteInfoCard_InfoLine, {
                                children: creditCard && "".concat(creditCard === null || creditCard === void 0 ? void 0 : creditCard.brand, " - ").concat(creditCard === null || creditCard === void 0 ? void 0 : creditCard.lastDigits)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/EmptyCart.tsx
function EmptyCart_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EmptyCart_templateObject() {
    var data = EmptyCart_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n"
    ]);
    EmptyCart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var EmptyContainer = styled_components_browser_esm["default"].div(EmptyCart_templateObject());
function EmptyCart(param) {
    var inCheckout = param.inCheckout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
            spacing: 50,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.H4, {
                        withGutter: true,
                        children: [
                            " ",
                            inCheckout ? "Karfan \xfe\xedn er t\xf3m" : "Karfan er t\xf3m"
                        ]
                    }),
                    inCheckout && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                        color: "black60",
                        children: "\xde\xfa \xfearft a\xf0 vera me\xf0 v\xf6rur \xed k\xf6rfu til \xfeess a\xf0 halda \xe1fram me\xf0 kaupferli."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                        withGutter: true,
                        color: "black60",
                        children: "B\xe6ttu \xfar \xfev\xed me\xf0 \xfev\xed a\xf0 sko\xf0a v\xf6rur \xed vefversluninni okkar!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: (0,paths/* generatePath */.G)(paths/* paths.categories */.H.categories),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                            children: "Fara \xed vefverslun"
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/index.tsx





















/***/ })

}]);